import { createContext, useContext } from 'react';

const ScaleContext = /*#__PURE__*/createContext(1);
const useScale = () => {
  return useContext(ScaleContext);
};

export { ScaleContext, useScale };
//# sourceMappingURL=useScale.js.map
